import BaseException from './base_exception'

class MissingOnSave extends BaseException {
  constructor({ propertyName, field }) {
    super('hs.errors.missing_on_save', { propertyName, field })
  }
}

export default MissingOnSave
